
const initialState = {
    booleanAdditionalFeedbackModalIsDisplayed: false,
};


const feedbackReducer = (state = initialState, action) => {


    
    switch (action.type) {

        case 'UPDATE_FEEDBACK_Q1':

            return {
                ...state,
                booleanAdditionalFeedbackModalIsDisplayed: action.booleanAdditionalFeedbackModalIsDisplayed,
            }
        
        case 'CREATE_FEEDBACK_Q1_ERROR':

            return state;



        case 'UPDATE_FEEDBACK_Q2':

            return {
                ...state,
                booleanAdditionalFeedbackModalIsDisplayed: action.booleanAdditionalFeedbackModalIsDisplayed,
            }
        
        case 'CREATE_FEEDBACK_Q2_ERROR':

            return state;
        

        
        case 'UPDATE_FEEDBACK_Q3':

            return {
                ...state,
                booleanAdditionalFeedbackModalIsDisplayed: action.booleanAdditionalFeedbackModalIsDisplayed,
            }
        
        case 'CREATE_FEEDBACK_Q3_ERROR':

            return state;
            
            

        case 'UPDATE_FEEDBACK_Q4':

            return {
                ...state,
                booleanAdditionalFeedbackModalIsDisplayed: action.booleanAdditionalFeedbackModalIsDisplayed,
            }
        
        case 'CREATE_FEEDBACK_Q4_ERROR':

            return state;


        case 'UPDATE_FEEDBACK_Q5':

            return {
                ...state,
                booleanAdditionalFeedbackModalIsDisplayed: action.booleanAdditionalFeedbackModalIsDisplayed,
            }
        
        case 'CREATE_FEEDBACK_Q5_ERROR':

            return state;





        default:
            return state;
    }
    
   

}

export default feedbackReducer